export default class ServicesPro {
  constructor(element) {
    this.element = element;
    this.activeService = this.element.querySelector(
      '.service-title.text-black'
    );
    this.init();
  }

  init() {
    const services = this.element.querySelectorAll('.service-title');
    this.servicesContent = this.element.querySelectorAll('.service-content');

    services.forEach((service) => {
      service.addEventListener('click', this.active.bind(this));
    });
  }

  active(event) {
    const target = event.currentTarget;

    if (this.activeService && this.activeService !== target) {
      this.activeService.classList.remove('text-black');
      this.activeService.classList.add('text-gray');
    }

    target.classList.add('text-black');
    target.classList.remove('text-gray');

    this.activeService = target;

    const id = target.dataset.content;
    this.servicesContent.forEach((content) => {
      if (content.id === id) {
        if (content.classList.contains('d-none')) {
          content.classList.remove('d-none');
          content.classList.add('service-pro-transition');
        }
      } else {
        content.classList.add('d-none');
        content.classList.remove('service-pro-transition');
      }
    });
  }
}
